var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-2 font-weight-bold",class:{ 'text-muted': _vm.disabled == 'true' }},[_c('b-icon',{attrs:{"icon":_vm.icon}}),_c('span',{staticClass:"p-4"},[_vm._v(_vm._s(_vm.name))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }